module.exports = __webpack_public_path__ + "static/media/vascularization-Figure4-L.710fe41f.jpg";